/*
 * @Author: lihaitao
 * @Date: 2020-05-11 17:03:33
 * @Last Modified by: lihaitao
 * @Last Modified time: 2020-06-02 21:15:18
 */
import OSS from 'ali-oss';
import COS from 'cos-js-sdk-v5';
/**
 * 多云上传类
 */
class DsCloud {
    constructor(config) {
        /**
         * 阿里云 OSS 初始化实例
         */
        this.ossClient = null;
        /**
         * 腾讯云 COS 初始化实例
         */
        this.cosClient = null;
        this.config = config;
        this.init();
    }
    init() {
        // 检查参数是否正确
        // 初始化默认参数
        const { type } = this.config;
        if (type === 'oss') {
            this.initOSS();
        }
        else {
            this.initCOS();
        }
    }
    /**
     * 初始化阿里云 OSS SDK
     */
    initOSS() {
        const { region, accessKeyId, accessKeySecret, stsToken, bucket, secure } = this.config;
        this.ossClient = new OSS({
            region,
            accessKeyId,
            accessKeySecret,
            stsToken,
            bucket,
            secure
        });
    }
    /**
     * 初始化腾讯云 OSS SDK
     */
    initCOS() {
        const { accessKeyId, accessKeySecret, stsToken, startTime, expiredTime } = this.config;
        this.cosClient = new COS({
            getAuthorization: (options, callback) => {
                console.log(options);
                callback({
                    TmpSecretId: accessKeyId,
                    TmpSecretKey: accessKeySecret,
                    XCosSecurityToken: stsToken,
                    StartTime: startTime,
                    ExpiredTime: expiredTime
                });
            }
        });
    }
    /**
     * 分片上传
     * @param file 文件对象
     * @param Options 配置参数
     */
    multipartUpload(file, options) {
        const { key, headers, type, region, bucket } = this.config;
        if (type === 'oss') {
            return new Promise((resolve, reject) => {
                this.ossClient.multipartUpload(key, file, {
                    headers,
                    ...options
                }).then(({ res }) => {
                    const { status, requestUrls } = res;
                    if (status === 200) {
                        // 处理返回需要的参数，目前只用到了上传成功之后的链接
                        resolve({
                            status,
                            data: {
                                url: requestUrls[0].split('?uploadId=')[0],
                                key: requestUrls[0].split('aliyuncs.com/')[1]
                            }
                        });
                    }
                    else {
                        reject({
                            error: {
                                message: '上传失败'
                            }
                        });
                    }
                });
            });
        }
        else {
            return new Promise((resolve, reject) => {
                this.cosClient.sliceUploadFile({
                    Bucket: bucket,
                    Region: region,
                    Key: key,
                    Body: file,
                    Headers: headers,
                    onProgress: ({ percent }) => {
                        options.progress(percent);
                    }
                }, (error, data) => {
                    if (!error) {
                        const { statusCode, Location, Key } = data;
                        resolve({
                            status: statusCode,
                            data: {
                                url: this.getCosObjectUrl(this.config.secure, Location),
                                key: Key
                            }
                        });
                    }
                    else {
                        reject({
                            message: '上传失败'
                        });
                    }
                });
            });
        }
    }
    /**
     * 获取是否开启 https 对象链接
     * @param secure 是否开启 htttps
     * @param url 对象上传路径
     */
    getCosObjectUrl(secure, url) {
        return secure ? `https://${url}` : `http://${url}`;
    }
}
export default DsCloud;
//# sourceMappingURL=data:application/json;base64,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